import { Component, OnInit, ChangeDetectorRef, ViewChildren, QueryList, ElementRef, OnDestroy, Renderer2, ViewChild } from '@angular/core';
import { WidgetService } from '../../services/widget.service';
import { CardComponent } from '../../shared/components/card/card.component';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { CookieService} from 'ngx-cookie';
import { GenericService } from '../../services/generic.service';
import { Subscription, take } from 'rxjs';
import { identifierName } from '@angular/compiler';
import * as CryptoJS from 'crypto-js'; 
import { environment } from '../../../environments/environment';
import { WindowRefService } from '../../services/window-ref.service';
//const crypto = require('crypto'); //need initialize crypto package here



//TimingSafeEqual Function
function timingSafeEqual(a: string, b: string): boolean {
  if (a.length !== b.length) {
    return false;
  }
  let result = 0;
  for (let i = 0; i < a.length; i++) {
    result |= a.charCodeAt(i) ^ b.charCodeAt(i);
  }
  return result === 0;
}


//hashing function
function verifyTimeBoundHash(plaintext:string, base64Hash:string, maxAgeMs:number) {
  try {
      const payloadStr = atob(base64Hash);
      const { salt, timestamp, hash } = JSON.parse(payloadStr);
      const now = Date.now();
      if (now - timestamp > maxAgeMs) {
          return 'Expired'; // Expired
      }
      const combinedInput = `${plaintext}:${timestamp}`;
      const regeneratedHash = CryptoJS.PBKDF2(combinedInput, CryptoJS.enc.Hex.parse(salt), {
        keySize: 256 / 32,
        iterations: 100000
      }).toString(CryptoJS.enc.Hex);
      console.log(regeneratedHash);
      return timingSafeEqual(regeneratedHash, hash);
  } catch (error) {
      console.error("Verification error:", error);
      return false;
  }
}

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CardComponent, CommonModule],
  providers: [CookieService],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent implements OnInit, OnDestroy {
  allParams: { [key: string]: string } = {};
  login_hint: any = null;
  step: any = null;
  currentStep: any;
  widget: any;
  sparkStatusHash = '';
  redirectUri= '';
  userJourney = '';
  @ViewChildren('otpBox') boxes!: QueryList<ElementRef<HTMLInputElement>>;
  @ViewChild('IDToken1', {static:false}) idtoken!: ElementRef | undefined;
  hiddenInput = document.getElementById('otp-hidden') as HTMLInputElement;
  otpValue = ''
  otp: string[] = Array(6).fill('');
  otpCallback: any;
  subscriptions: Subscription;
  constructor(
    private widgetSrv: WidgetService,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private genericService: GenericService,
    private renderer: Renderer2,
    private cookieService: CookieService,
    private router: Router,
    private windowRef: WindowRefService,
    

  ) { 
    this.subscriptions = new Subscription();
  }  

  //resolve user jouney
  resolveUserJourney(sparkHash: string, environment: { [key: string]: string }, redirectUri: string): string {
    // call function sparkStatusCheck(hashvalue) -- returns the journey against the original value
    if( redirectUri.includes('myprofile')) {
      return environment['myprofile']
    } 
    for (const key of Object.keys(environment)) {
      const result = verifyTimeBoundHash(key, sparkHash, 5*60*1000); //currently set to 5 mins. Can be passed through environment variable
      if (result === true) {
        //console.log('Matched Key -> ' + key);
        return environment[key];
      } else if (result === 'Expired') {
        //console.warn('Hash has expired');
        return environment['default']; //if the hash expired
      }
    }
    console.warn('Hash not found');
    return environment['default']; //if no match is found
  }


  ngOnDestroy(): void {
      this.subscriptions.unsubscribe()
  }
  ngOnInit(): void {
    this.subscriptions.add(this.route.queryParamMap.subscribe((params: any) => {
      params.keys.forEach((key: any) => {
        console.log('key', key)
        if (key == 'goto') {
          const url = new URL(params.get(key), window.location.origin);
          this.login_hint = url.searchParams.get('login_hint') || null;
          this.sparkStatusHash = url.searchParams.get('Spark_Status') || '';
          this.redirectUri = url.searchParams.get('redirect_uri') || '';
          //this.sparkStatusHash = url.searchParams.get('Spark_Status') || ''; //hashed code
          //need to remove the hardcoded hash
          //console.log(this.sparkStatusHash + "-> hello");
        }
        this.allParams[key] = params.get(key) || '';
        //console.log(this.allParams)
      });
      this.cdr.detectChanges();
    }));
    if(this.sparkStatusHash == '') this.sparkStatusHash = this.allParams['Spark_Status'];
    console.log('SparStatus', this.sparkStatusHash)
    //need to remove the hardcoded hash
    //this.sparkStatusHash = 'eyJzYWx0IjoiMWU1YmQzZjlmYmM5ZTg5MWVhZjA5NTRlZDY5ZDAwNjIiLCJ0aW1lc3RhbXAiOjE3NDY2OTUyMTEzMDUsImhhc2giOiI1MDI2NDAyMDFiYzQ4Y2NhYmIyYzAyYTI5MmQ0YWVlOWY1YzQxMjI3MzFmYTIwNmE2ZWIyNjRkMjVhMDI1NDVlIn0='
    
    
    // call function to resolve the journey

      this.userJourney = this.resolveUserJourney(this.sparkStatusHash, environment.journeyOptions,this.redirectUri );
    
    //load widget with the jouney
    console.log(this.userJourney);
      this.showWidget(this.userJourney);
    //this.showWidget();
    setTimeout(() => {
      this.genericService.setPlaceholder('#IDToken1', 'Password');
    },1000);
  }
  onInput(event: Event, index: number){
    const input = event.target as HTMLInputElement;
    const value = input.value;
    if(value.length === 1 && index < this.boxes.length -1 ) {
      this.boxes.get(index + 1)?.nativeElement.focus()
    }
    this.updateOtpValue(value)
  }
  updateOtpValue(value: string) {
    const otpInput = document.getElementById('IDToken1') as HTMLInputElement
    const otpValue = this.boxes.toArray().map((e)=>e.nativeElement.value).join('');
    if(otpInput) {
      otpInput.focus();
      otpInput.value =  otpValue
      this.otpValue =  otpValue
      this.otpCallback.payload.input[0].value = this.otpValue
      otpInput.dispatchEvent(new Event('input', { bubbles: true}))
      otpInput.blur();
    }
 
  
  }
  onClickContinue() {
      this.otpCallback.payload.input[0].value = this.otpValue
      this.widget.next(this.currentStep)
  }
  onKeyDown(event: KeyboardEvent, index: number) {
    const input = event.target as HTMLInputElement
    if(event.key === 'Backspace' && !input.value && index > 0) {
      this.boxes.get(index - 1)?.nativeElement.focus()
    }
  }
  showWidget(userJourney: string) {
    //this.widget = this.widgetSrv.setWidget('Spark_ForgotPassword');
   this.widget = this.widgetSrv.setWidget(userJourney);
    if(this.widget) this.subscriptions.add(this.widget
    .subscribe((event:any) => {
      /* Run anything you want */
      if(event.journey?.step?.type == 'Step') {
        this.currentStep = event.journey.step;
        const otpCallback = event.journey.step.callbacks?.find(
          (cb:any) => cb.payload?.input?.[0]?.name === 'IDToken1'
        )
        if(otpCallback) {
          this.otpCallback = otpCallback
        }
      }
      if(event.journey.step?.payload?.callbacks?.length) {
        this.step = event.journey.step?.payload?.callbacks.map((val:any)=>val.type).join("-")
        //console.log('Current step => ', this.step)
         if(this.step === 'PasswordCallback') {
           setTimeout(() => {
             this.addElement();
           }, 1000);
         }
         if(this.step === 'NameCallback-ConfirmationCallback') {
          setTimeout(() => {
            const inp = document.querySelector('#IDToken1') as HTMLElement

            inp.style.display = 'none'
          }, 1000);
        }
      } else {
        this.step = null
      }
      if(event.journey.completed){
        if(this.allParams['goto']) {
          //console.log(this.allParams)
          window.open(this.allParams['goto'], '_self');
        } else {
          const url = this.cookieService.get('urlWithParams');
          //console.log(url)

          window.open(url, '_self');
        }
      }
    }));
    
  }

  addElement() {
    // const targetEl = document.querySelector(selector);
    console.log('creando el forgot pass')
    const parent = document.getElementById('genericStepForm')
    const newLink = document.createElement('a');
    newLink.style.cursor = 'pointer'
    newLink.text = 'Forgotten password?'
    newLink.classList.add('forgotten')
    newLink.addEventListener('click', (event)=>{
      event.preventDefault()
      this.router.navigate(['/recovery/password'])
    })
    console.log(parent);
    console.log(newLink)

    if(parent) {
      parent.style.position = 'relative'

       parent.insertBefore( newLink, parent.firstChild);
      // targetEl.insertAdjacentElement('afterend', newLink);
    }

  }

  changeAccount() {
    localStorage.removeItem('email');
    if(this.redirectUri !== ''){
     
            this.windowRef.open(this.redirectUri.replace('/callback',''), '_self');


    } else {

      this.router.navigate(['/discovery'])
    }
  }

 
}
